// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { IInvestmentVariables, ILoanParams, IPropertyInfo } from "src/app/services/poperty.service";

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.


export interface IEnvironment {
  production: boolean;
  
  seedData?: any;
  sampleProperties?: ISampleProperty[];

  title: string;
  env?: string;

  firebaseConfig: IFirebaseConfig;
}

/**
 * 
 */
export interface IFirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
}

/**
 * 
 */
export interface ISampleProperty {
  code: string;
  propertyInfo: IPropertyInfo;
  loanParams: ILoanParams;
  investmentVariables: IInvestmentVariables;
}

/**
 * 
 */
export class SeedData {
  
  /**
   * 
   */
  public static myProperties: ISampleProperty[] = [
    {
      code: undefined,
      propertyInfo: {
        name: 'Cape Coral',
        address: '3928 NE 19th Place',
        description: '3 bed, 2 bath',

        photoFileEntryList: {
          fileEntries: [
          ],
          primaryImageCode: undefined
        },

        purchasePrice: 331000,
        purchaseDate: undefined,
        purchaseCosts: 2383 * 8 /* 8 months of 11% Interest Only payments for 260,000 */,

        initialValues: {
          marketValue: 420000,
          monthlyRevenue: 2700,
          monthlyExpenses: {
            hoa: 0,
            utilities: 0,
            grounds: 0,
            other: 0
          },
          yearlyExpenses: {
            taxes: 4000,
            insurance: 1500,
          }
        }
      },
      loanParams: {
        percentDown: (46000 /* lot */ + 28500 /* 10% */) / ((285000 /* build price */ - 28500 /* 10% */) + 46000 /* lot */),
        rate: 7,
        years: 30,
        closingCosts: 5700
      },
      investmentVariables: {
        propertyAppreciation: 3.0,
        rentalAppreciation: 3.0,
        propertyManagement: 8.0,
        maintenance: 0.0,
        vacancy: 0.0,
        taxBracket: 33.0,
        saleCommission: 6.0,
        saleClosingCosts: .5,
        expenseInflation: 2.0,
        depreciationYears: 27.5
      }
    },
    {
      code: undefined,
      propertyInfo: {
        name: 'Pine Ave.',
        address: '137 E Pine Ave, Wildwood NJ',
        description: '3 bed, 2 bath, 1st floor',

        photoFileEntryList: {
          fileEntries: [
          ],
          primaryImageCode: undefined
        },

        purchasePrice: 569000,
        purchaseDate: undefined,
        purchaseCosts: 0,

        initialValues: {
          marketValue: 590000,
          monthlyRevenue: 38000 / 12,
          monthlyExpenses: {
            hoa: 2000 / 12,
            utilities: 3000 / 12,
            grounds: 0,
            other: 0
          },
          yearlyExpenses: {
            taxes: 3200,
            insurance: 1200,
          }
        }
      },
      loanParams: {
        percentDown: 35.14,
        rate: 6.5,
        years: 30,
        closingCosts: 5700
      },
      investmentVariables: {
        propertyAppreciation: 3.0,
        rentalAppreciation: 3.0,
        propertyManagement: 0.0,
        maintenance: 0.0,
        vacancy: 0.0,
        taxBracket: 33.0,
        saleCommission: 6.0,
        saleClosingCosts: .5,
        expenseInflation: 2.0,
        depreciationYears: 39
      }
    },
    {
      code: undefined,
      propertyInfo: {
        name: 'Central',
        address: '841 Central Ave #3',
        description: '4 bed, 2 bath, 3rd floor',

        photoFileEntryList: {
          fileEntries: [
          ],
          primaryImageCode: undefined
        },

        purchasePrice: 649000,
        purchaseDate: undefined,
        purchaseCosts: 0,

        initialValues: {
          marketValue: 750000,
          monthlyRevenue: 59000 / 12,
          monthlyExpenses: {
            hoa: 4500 / 12,
            utilities: 5000 / 12,
            grounds: 0,
            other: 0
          },
          yearlyExpenses: {
            taxes: 5000,
            insurance: 1200,
          }
        }
      },
      loanParams: {
        percentDown: 20,
        rate: 2.9,
        years: 30,
        closingCosts: 5700
      },
      investmentVariables: {
        propertyAppreciation: 3.0,
        rentalAppreciation: 3.0,
        propertyManagement: 0.0,
        maintenance: 0.0,
        vacancy: 0.0,
        taxBracket: 33.0,
        saleCommission: 6.0,
        saleClosingCosts: .5,
        expenseInflation: 2.0,
        depreciationYears: 39
      }
    },
  ];
  
  /**
   * 
   */
  public static sampleProperties: ISampleProperty[] = [
    {
      code: undefined,
      propertyInfo: {
        name: '312 Columbus Ave.',
        address: '312 Columbus Ave. NW, Canton, OH 44708',
        description: '4 bed, 1.5 bath, 1248 sq., 1916, class b',

        photoFileEntryList: {
          fileEntries: [
            { code: 'p1-01', name: 'Main', fileUrl: './assets/312-columbus-ave-canton-oh-44708.png' }
          ],
          primaryImageCode: 'p1-01'
        },

        purchasePrice: 145000,
        purchaseDate: undefined,
        purchaseCosts: 0,

        initialValues: {
          marketValue: 145000,
          monthlyRevenue: 1150,
          monthlyExpenses: {
            hoa: 0,
            utilities: 0,
            grounds: 0,
            other: 0
          },
          yearlyExpenses: {
            taxes: 713,
            insurance: 700,
          }
        }
      },
      loanParams: {
        percentDown: 20.0,
        rate: 6.0,
        years: 30,
        closingCosts: 4000
      },
      investmentVariables: {
        propertyAppreciation: 4.0,
        rentalAppreciation: 3.0,
        propertyManagement: 8.0,
        maintenance: 3.0,
        vacancy: 3.0,
        taxBracket: 30.0,
        saleCommission: 6.0,
        saleClosingCosts: .5,
        expenseInflation: 2.0,
        depreciationYears: 27.5
      }
    },
    {
      code: undefined,
      propertyInfo: {
        name: '416 E South Ave',
        address: '416 E South Ave., Independence, MO 64050',
        description: '2 bed, 1 bath, 685 sq., 1949, class b',

        photoFileEntryList: {
          fileEntries: [
            { code: 'p2-01', name: 'Main', fileUrl: './assets/416-e-south-ave-independence-mo-64050.png' }
          ],
          primaryImageCode: 'p2-01'
        },

        purchasePrice: 125000,
        purchaseDate: undefined,
        purchaseCosts: 0,

        initialValues: {
          marketValue: 125000,
          monthlyRevenue: 1095,
          monthlyExpenses: {
            hoa: 0,
            utilities: 0,
            grounds: 0,
            other: 0
          },
          yearlyExpenses: {
            taxes: 843,
            insurance: 1162,
          }
        }
      },
      loanParams: {
        percentDown: 20.0,
        rate: 6.0,
        years: 30,
        closingCosts: 4000
      },
      investmentVariables: {
        propertyAppreciation: 4.0,
        rentalAppreciation: 3.0,
        propertyManagement: 8.0,
        maintenance: 3.0,
        vacancy: 3.0,
        taxBracket: 30.0,
        saleCommission: 6.0,
        saleClosingCosts: .5,
        expenseInflation: 2.0,
        depreciationYears: 27.5
      }
    },
    {
      code: undefined,
      propertyInfo: {
        name: '3031 Gronton',
        address: '3031 Gronton, Houston, TX 77051',
        description: '4 bed, 2 bath, 1360 sq., 1961, class b',

        photoFileEntryList: {
          fileEntries: [
            { code: 'p3-01', name: 'Main', fileUrl: './assets/3031-gronton-houston-tx-77051.png' }
          ],
          primaryImageCode: 'p3-01'
        },

        purchasePrice: 220000,
        purchaseDate: undefined,
        purchaseCosts: 0,

        initialValues: {
          marketValue: 220000,
          monthlyRevenue: 1500,
          monthlyExpenses: {
            hoa: 0,
            utilities: 0,
            grounds: 0,
            other: 0
          },
          yearlyExpenses: {
            taxes: 1756,
            insurance: 1154,
          }
        }
      },
      loanParams: {
        percentDown: 20.0,
        rate: 6.0,
        years: 30,
        closingCosts: 4000
      },
      investmentVariables: {
        propertyAppreciation: 4.0,
        rentalAppreciation: 3.0,
        propertyManagement: 8.0,
        maintenance: 3.0,
        vacancy: 3.0,
        taxBracket: 30.0,
        saleCommission: 6.0,
        saleClosingCosts: .5,
        expenseInflation: 2.0,
        depreciationYears: 27.5
      }
    },
    {
      code: undefined,
      propertyInfo: {
        name: '3244 Winder Dr.',
        address: '3244 Winder Dr., Holiday, FL 34691',
        description: '2 bed, 2 bath, 1045 sq., 1969, class b',

        photoFileEntryList: {
          fileEntries: [
            { code: 'p4-01', name: 'Main', fileUrl: './assets/3244-winder-dr-holiday-fl-34691.png' }
          ],
          primaryImageCode: 'p4-01'
        },
        
        purchasePrice: 245125,
        purchaseDate: undefined,
        purchaseCosts: 0,
        
        initialValues: {
          marketValue: 245125,
          monthlyRevenue: 1900,
          monthlyExpenses: {
            hoa: 0,
            utilities: 0,
            grounds: 0,
            other: 0
          },
          yearlyExpenses: {
            taxes: 2399,
            insurance: 1400,
          }
        }
      },
      loanParams: {
        percentDown: 20.0,
        rate: 6.0,
        years: 30,
        closingCosts: 4000
      },
      investmentVariables: {
        propertyAppreciation: 4.0,
        rentalAppreciation: 3.0,
        propertyManagement: 8.0,
        maintenance: 3.0,
        vacancy: 3.0,
        taxBracket: 30.0,
        saleCommission: 6.0,
        saleClosingCosts: .5,
        expenseInflation: 2.0,
        depreciationYears: 27.5
      }
    },
    {
      code: undefined,
      propertyInfo: {
        name: '4436 Monroe Ave.',
        address: '4436 Monroe Ave., Kansas City, MO 64130',
        description: '3 bed, 3 bath, 1391 sq., 1949, class b',

        photoFileEntryList: {
          fileEntries: [
            { code: 'p5-01', name: 'Main', fileUrl: './assets/4436-monroe-ave-kansas-city-mo-64130.png' }
          ],
          primaryImageCode: 'p5-01'
        },

        purchasePrice: 155000,
        purchaseDate: undefined,
        purchaseCosts: 0,
        
        initialValues: {
          marketValue: 155000,
          monthlyRevenue: 1295,
          monthlyExpenses: {
            hoa: 0,
            utilities: 0,
            grounds: 0,
            other: 0
          },
          yearlyExpenses: {
            taxes: 361,
            insurance: 1302,
          }
        }
      },
      loanParams: {
        percentDown: 20.0,
        rate: 6.0,
        years: 30,
        closingCosts: 4000
      },
      investmentVariables: {
        propertyAppreciation: 4.0,
        rentalAppreciation: 3.0,
        propertyManagement: 8.0,
        maintenance: 3.0,
        vacancy: 3.0,
        taxBracket: 30.0,
        saleCommission: 6.0,
        saleClosingCosts: .5,
        expenseInflation: 2.0,
        depreciationYears: 27.5
      }
    }
  ];
}